import { createFileRoute } from "@tanstack/react-router"

import { DesktopActivity } from "@/crm/components/activity/desktop/activity"
import { MobileActivity } from "@/crm/components/activity/mobile/activity"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/activity")({
  component: ActivityRoute,
})

function ActivityRoute() {
  return <Adaptive desktop={<DesktopActivity />} mobile={<MobileActivity />} />
}
